import FJViewConstant from "../../constant/FJViewConstant";
import FJActionConstant from "../../constant/FJActionConstant";

const initialState = {
  overLimitContents: [],
  paymentLevel: FJViewConstant.USER_PAYMENT_FREE,
};

export default function payment(state = initialState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_USER_LIMIT_STATUS: {
      return {
        ...state,
        overLimitContents: [...action.limits],
      }
    }
    case FJActionConstant.UPDATE_USER_PAYMENT_LEVEL: {
      return {
        ...state,
        paymentLevel: action.paymentLevel,
      }
    }
    default:
      return state;
  }
}
